import { SdgDrillDownTableRow } from '@upright/common/model/output/scores/sdg-alignment/api-types';
import { formatAlignmentValue } from '@upright/ui/common/upright/model/output/scores/eu-taxonomy/utils';
import styled from 'styled-components';

interface Props {
  data: SdgDrillDownTableRow;
}

export function AlignmentNumberCell(props: Props) {
  return <Root>{formatAlignmentValue(props.data.alignment)}</Root>;
}

const Root = styled.div`
  text-align: right;
`;
